import styles from './CircularProgress.module.css';

export const CircularProgress = ({ percent, color = '#72ffb8' }) => {
  const viewBoxSize = 100;
  const radius = 45;
  const circumference = 2 * Math.PI * radius;

  const dashOffset = circumference - (percent / 100) * circumference;

  return (
    <svg
      width="100%"
      height="100%"
      viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
      style={{ transform: 'scaleX(-1)' }}
    >
      <circle
        cx={viewBoxSize / 2}
        cy={viewBoxSize / 2}
        r={radius}
        stroke={color}
        strokeWidth="8"
        fill="none"
        className={styles.percent}
        strokeDasharray={circumference}
        strokeLinecap="square"
        transform={`rotate(-90 ${viewBoxSize / 2} ${viewBoxSize / 2})`}
        style={{
          '--circumference': circumference,
          '--dashOffset': dashOffset,
          strokeDashoffset: dashOffset,
        }}
      />
    </svg>
  );
};
